import { CSSProperties } from '@mui/material'

import { DigitalResearchNotebookIcon } from './DigitalResearchNotebookIcon'
import { ImpactTrackerIcon } from './ImpactTrackerIcon'
import { StorageIcon } from './StorageIcon'

type Props = {
  color: CSSProperties['color']
  serviceCode: 'DRN' | 'IMPACT_TRACKER' | 'STORAGE'
  style?: React.CSSProperties
}

export const RecordServiceIcon = (props: Props) => {
  const color = props.color || '#000'
  const style = { height: 35, width: 35, fill: color, ...props.style }

  if (props.serviceCode === 'DRN') {
    return <DigitalResearchNotebookIcon style={style} />
  } else if (props.serviceCode === 'IMPACT_TRACKER') {
    return <ImpactTrackerIcon style={style} />
  }

  return <StorageIcon style={style} sx={{ color }} />
}
